import Vue from 'vue'

Vue.component('dashboard-default', require('./Components/Views/Demo/Dashboard/Default').default);





